import React, { Component } from 'react';
import { WithStyles, Grid, withStyles, Button, Chip, Tooltip } from '@material-ui/core';
import { courseLandingPageStyles } from '../../../../../styles';
import CoursePlanPreview from './CoursePlanPreview';
import { HeadingComponent, CoursePlan, CombinedPhases, NoContent } from '../../../..';
// import { setGetPackageById, getListOfCourses } from './helpers';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contentManagementAction } from '../../../../../reducers/contentMangementData';
import _ from 'lodash';
import AdvancedSettings from '../../../../AdvancedSettings/AdvancedSettings';
import courseManagementServices from '../../../../../service/courseManagementServices';
import { createCoursePlanStatesAction } from '../../../../../reducers/createCoursePlanReducer';
import { contentManagementService } from '../../../../../service';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TabPanel from '../../../../../../userManagement/common/TabPanel';
import { RouteComponentProps } from 'react-router';
import BasicInfo from '../../../../BasicInfo/BasicInfo';
import { BasicInfoType } from '../../../../../types/enums/BasicInfoType';
import { createCoursePlanPayload } from '../../../helpers/CoursePlanHelper';
import { showMsg } from '../../../../../../course/actions/loaderAlert';
import { CourseTypes } from '../../../../../types/enums/CourseTypes';
import CourseVersionPopup from './CourseVersionPopup';
import classNames from 'classnames';
import { ProcessingStatus } from '../../../../../types/enums/ProcessingStatus';
import {} from '../../'
import ACLService from "../../../../../../acl/services/aclService";
import EditLockedInfoPopUp from '../../../../PopUp/EditLockedInfoPopUp';
import { checkForCreatedByUser, checkForCreationForRight, checkForEditRight, checkForPublishRight, getRequestId } from '../../../../../helpers/helpers';
import { CONTENT_STATUS, HISTORY_TYPE, MODULES } from '../../../../../../../constants/comman';
import { COURSE_CHANGE_TAB, REQUEST_STATUS } from '../../../../../types/enums/RequestStatus';
import { approveAndPublishCourse, rejectCourse } from '../../../../../actions/courseManagementActions';
import { COURSES_TAB, PUBLISH_OPTIONS, REQUEST_CHANGES, COURSE_CHANGE, DATE_PARAMS, WEEK_DAYS, COURSE_VIEW_LIST, ENTITY_TYPE } from '../../../../../Constants/constants';
import { courseManagementActions } from '../../../../../reducers/courseManagementReducer';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import cx from 'classnames';

import HourAllocation from '../../../../HourAllocation';
import { MyPATDialog } from '../../../../../../common';
interface RouteParams {
  id?: string;
  type?:string;
}

interface PreviewLandingPageProps extends WithStyles<typeof courseLandingPageStyles>, RouteComponentProps<RouteParams> {
  classes: any;
  setPackageById: Function;
  setPackages: Function;
  getPackageByIdData: any;
  getPackages: any;
  treeData: any;
  selectedCourseData: any[];
  coursePlanResponse: any;
  setCoursePlanResponse: Function;
  setSelectedCourseData: Function;
  history: any;
  courseRequest: any;
  setCoursePlanStates: Function;
  coursePlanState: any;
  setCourseSyllabus: Function;
  courseSyllabus: any;
  setChaptersSubject: Function;
  totalSubjectChapters: any;
  showMsg: Function;
  viewPlanData: any;
  rejectCourse: any;
  approveAndPublishCourse: Function;
  setRejectionRemark: Function;
  setCourseRequest: any;
  setActiveCoursePlanView: any,
}
interface PreviewLandingPageState {
  activeComponent: string;
  coursePlanId: string;
  activeTab: any;
  requiredSaveButton?: boolean;
  isGoalCombo?: boolean;
  showVersionPopup: boolean;
  goalList: any;
  processingStatus: ProcessingStatus,
  hasDuplicateRight:boolean,
  disableEditBttn:boolean,
  showEditLockPopUp:boolean,
  showHistoryDropDown:boolean,
  historyList: any,
  coursePlanViewModelVisible: boolean;
  activeCoursePlanView:string,
}

class PreviewLandingPage extends Component<PreviewLandingPageProps, PreviewLandingPageState> {
  constructor(props: PreviewLandingPageProps) {
    super(props);
    this.state = {
      activeComponent: 'CoursePlan',
      coursePlanId: '',
      activeTab: 0,
      showVersionPopup: false,
      goalList: [],
      processingStatus: ProcessingStatus.DRAFT,
      hasDuplicateRight:false,
      disableEditBttn:false,
      showEditLockPopUp:false,
      showHistoryDropDown: false,
      historyList: [],
      coursePlanViewModelVisible:false,
      activeCoursePlanView: ENTITY_TYPE.PHASE,
    };
  }
  processedList = [REQUEST_STATUS.ACCEPTED, REQUEST_STATUS.REJECTED, REQUEST_STATUS.CLOSED];

  toggleVersionPopup = () => {
    this.setState({
      showVersionPopup: !this.state.showVersionPopup,
    });
  }

  toggleHistoryDropDown = () => {
    this.setState({
      showHistoryDropDown: !this.state.showHistoryDropDown,
    })
  }

  getDayOfWeek(dateInput: any) {
    dateInput = new Date(dateInput);
    return WEEK_DAYS[dateInput.getDay()];
  }

  padZero(value: number) {
    return value < 10 ? `0${value}` : value;
  }
  
  getFormattedTime(dateInput: any) {
    dateInput = new Date(dateInput);
    const hours = dateInput.getHours() % DATE_PARAMS.TWELVE_HOURS || DATE_PARAMS.TWELVE_HOURS;
    const minutes = dateInput.getMinutes();
    const ampm = dateInput.getHours() < DATE_PARAMS.TWELVE_HOURS ? DATE_PARAMS.AM : DATE_PARAMS.PM;
  
    return `${this.padZero(hours)}:${this.padZero(minutes)} ${ampm}`;
  }
  
  convertDateFormat = (dateInput: any) => {
    let date = new Date(dateInput);
    let dateFormat = date.getDate() + '/' +  (date.getMonth() + 1) + '/' + (date.getFullYear()%100);
    return dateFormat; 
  }

  getHistoryTitle = (type: any, center: any, user: any) => {
    switch (type) {
      case HISTORY_TYPE.CHANGE_REQUEST_SUBMITTED:
        return `Change request by ${user} from Centre ${center}.`;
      case HISTORY_TYPE.CHANGE_REQUEST_PUBLISHED:
        return `Change request by ${user} from the Centre ${center} has been published by NAO.`;
      case HISTORY_TYPE.CHANGE_REQUEST_REJECTED:
        return `Change request by ${user} from the Centre ${center} has been rejected by NAO.`;
      case HISTORY_TYPE.CHANGES_BULK_OPERATION:
        return `Course has been changed due to bulk operation.`;
      case HISTORY_TYPE.EDITED_PUBLISHED_DIRECTLY:
        return `Course has been edited and published by ${user} from Centre ${center}.`
      default:
        return 'Course has been changed.'
    }
  }

  componentDidMount = () => {
    const userData = ACLService.getUserDetailsFromStorage();
    const clientId = userData.authenticatedUser.aclMetaData.clientId;
    // const fullName = userData.authenticatedUser.fullName;
    // const clientID = userData.authenticatedUser.id;

    const { params: { id = ''} } = this.props.match;
    courseManagementServices.getPackageById(id).then((response: any)=>{
      const { packageData } = response.responseObject
      if(packageData.coursePlanId && packageData.status !== 'DRAFT') {
        const goalLevel = _.get(packageData.courseDetails, '[0].courseType.id');
        contentManagementService.getGoalLevel(goalLevel).then((res: any) => {
          let valuelist: any = [];
          res.goalLevels.forEach((ele: any) => {
            let element = { id: ele._id, label: ele.name, value:ele.name,isRemovable:true};
            valuelist.push(element);
          });
          this.setState({
            goalList: valuelist,
          });
          courseManagementServices.getHistory(packageData.coursePlanId || '').then((res: any) => {
            this.setState({historyList : res.coursePlanHistory || []});
          });
        });
      }
      const disableEditCTA= clientId!="5b5702e095cbc921944632a9" && clientId!=packageData.aclMetaData.clientId;

     this.props.setPackageById({ packageByIdData: { ...response.responseObject } });
     this.setState({disableEditBttn:disableEditCTA})
    });
    // checkModulePermission
    const hasDuplicateRight=ACLService.checkModulePermission("course","create");
    this.setState({hasDuplicateRight});
  }

  componentDidUpdate(prevProps: PreviewLandingPageProps) {
    const { viewPlanData: prevViewPlanData } = prevProps;
    const { viewPlanData } = this.props
    const prevViewPlanDataId = _.get(prevViewPlanData, '_id', '');
    const viewPlanDataId = _.get(viewPlanData, '_id', '');

    if(prevViewPlanDataId !== viewPlanDataId) {
      courseManagementServices.getPublishProcessStatus(viewPlanDataId).then((res: any) => {
        const status: ProcessingStatus = _.get(res, 'publishProcess.status', ProcessingStatus.DRAFT);
        this.setState({
          processingStatus: status
        })
      })
    }
  }
  componentWillUnmount(): void {
    this.props.setCourseRequest({});
  }
  toggleEditPopUp=()=>{
    this.setState({showEditLockPopUp:!this.state.showEditLockPopUp})
  }
  getStatusColorCode=(status:string)=>{
    const {classes } = this.props
    switch (status.toLowerCase()) {
      case "draft":
        return classes.draftColor
      case "live":
        return classes.liveColor
      case "past":
            return classes.pastColor
      default:
        return classes.publishColor
    }
  }
  handleTabSwitch = (event: any, newValue: any) => {
    this.setState({ activeTab: newValue || 0 });
  };

  a11yProps = (index: any) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  onEdit = (isDisable:boolean) => {
    const {viewPlanData}=this.props;
    if(isDisable){
      const isUpdateLocked=viewPlanData.isUpdateLocked;
      if(isUpdateLocked){
           this.setState({showEditLockPopUp:true});
      }
      return ; 
    }
    const courseId = _.get(this.props, 'getPackageByIdData._id', '');
    const coursePlanId = _.get(this.props, 'getPackageByIdData.coursePlanId', '');
    const type = _.get(this.props, 'getPackageByIdData.type', 'standard');
    const editingCourse = true;
    const includedPackages = _.get(this.props, 'getPackageByIdData.includedPackages')
    const courseMadeWith = includedPackages && includedPackages.length === 0 ? 'Goals' : 'Standard Course';
    
    let route;
    switch (type) {
      case CourseTypes.standard: {
        route = 'create-standard-course';
        break;
      }
      case CourseTypes.combo: {
        route = 'create-combo-course';
        break;
      }
      case CourseTypes.testSeries: {
        route = 'create-combo-course';
        break;
      }
      default:
        route = 'testSeries';
        break;
    }
    this.props.history.push(`/course-Management/${route}/${courseId}?coursePlanId=${coursePlanId}&editingCourse=${editingCourse}&type=${courseMadeWith}`);
   };
   duplicate=()=>{
    const { params: { id = ''} } = this.props.match;
    try{
      courseManagementServices.createDuplicatePackage({packageId:id}).then((res:any)=>{
        if(res.statusCode===200){
            //  const packageID=_.get(res,"responseObject.packageId","");
            this.props.showMsg(res.responseMessage,'success'); 
             setTimeout(()=>{
               this.props.history.replace(`/course-Management/`);
              },100);
        }else{
          this.props.showMsg(res.responseMessage,'error'); 
        }
      });
    }catch(err){
      console.log({err});
    } 
   }
   isCourseRequestProcessed() {
    const { courseRequest } = this.props;
    const requestStatus = courseRequest && courseRequest.status;
    let processed = this.processedList.includes(requestStatus);
    if (requestStatus === REQUEST_STATUS.AWAITING) {
      processed = processed || !checkForPublishRight(MODULES.COURSE);
    }

    return processed;
  }

  handleRejection = (requestStatus: string) => {
    this.props.setRejectionRemark(requestStatus);
  }

  getPublishText() {
    const { getPackageByIdData } = this.props;
    const editedCourse = checkForCreatedByUser(getPackageByIdData);
    const publishRight = checkForPublishRight(MODULES.COURSE);
    let publishText = PUBLISH_OPTIONS.SUBMIT_REQUEST;
    if (publishRight || editedCourse) {
      publishText = (editedCourse || !getRequestId()) ? PUBLISH_OPTIONS.PUBLISH : PUBLISH_OPTIONS.ACCEPT_AND_PUBLISH;
    }
    return publishText;
  }

  handlePublishCourse = () => {
    const requestId = getRequestId();
    const { getPackageByIdData } = this.props;
    if (requestId) {
      this.props.approveAndPublishCourse({ requestId, packageId: getPackageByIdData._id });
    }
  }

  handleHistoryClick = (requestId: any) => {
    let redirectionUrl = `/course-Management/coursePlanPreview/history/${requestId}`;
    this.props.history.push(redirectionUrl);
  }

  handleRedirectionClick = (event: any) => {
    let redirectionUrl = `/course-Management`;
    if (getRequestId()) {
      redirectionUrl += `/?activeTab=${COURSES_TAB.COURSE_CHANGE_REQUEST}`;
    }
    this.props.history.push(redirectionUrl);
  }

  checkVisibleForPublish() {
    const { getPackageByIdData } = this.props;
    const visiblePublish = [];

    if (!this.isCourseRequestProcessed()) {
      visiblePublish.push(checkForPublishRight(MODULES.COURSE));
      visiblePublish.push(checkForCreatedByUser(getPackageByIdData));
      visiblePublish.push(getPackageByIdData.status !== CONTENT_STATUS.DRAFT && checkForEditRight(getPackageByIdData, MODULES.COURSE));
    }
    return visiblePublish.some(visible => visible);
  }

  handleClickOutside() {
    this.setState({
      showHistoryDropDown: false,
    })
  }

  renderHeadingComponent = () => {
    const { classes, getPackageByIdData, viewPlanData } = this.props;
    const { processingStatus } = this.state;
   const { status, name, expiryDate } = getPackageByIdData;
   const isCourseExpired = new Date() > new Date(expiryDate);
   const isUpdateLocked = viewPlanData.isUpdateLocked || !viewPlanData.isEditable;
   const expiredStatus = 'expired';
   const expiredStatusFlag = 'past';
    const requestId = getRequestId();
    const isEditDisabled = processingStatus === ProcessingStatus.QUEUED || processingStatus === ProcessingStatus.STARTED||isUpdateLocked;
    const disablePublishButton = (getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId === null) || (getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId != null);
    const editContainerVisible = checkForEditRight(getPackageByIdData, MODULES.COURSE);
    const createContainerVisible = checkForCreationForRight(MODULES.COURSE);
    const editAddDuplicateContainerVisible = getPackageByIdData && !requestId;
    const publishContainerVisible = this.checkVisibleForPublish();
    const rejectedRequestVisible = requestId && checkForPublishRight(MODULES.COURSE) && !this.isCourseRequestProcessed();
    const hasBasPlanUpdated = this.props.courseRequest && this.props.courseRequest.basePlanUpdated;
    return (
      <Grid container>
        <Grid item xs>
          <span>
            <span className={classes.backArrow} style={{ cursor: 'pointer' }} onClick={this.handleRedirectionClick} >
              {/* <ArrowBackIcon/> */}
              {/* <img src="/assets/svg/left-arrowIcon.svg"/> */}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79 84"><path d="M32.7 15.9c1.4-1.4 3.6-1.4 5 0s1.4 3.6 0 5L12.1 46.4h84.3c2 0 3.5 1.6 3.5 3.5 0 2-1.6 3.6-3.5 3.6H12.1L37.7 79c1.4 1.4 1.4 3.7 0 5-1.4 1.4-3.7 1.4-5 0L1.1 52.5c-1.4-1.4-1.4-3.6 0-5l31.6-31.6z" fill="#666"></path></svg>
            </span>
            &nbsp;
                <span className={classes.backArrowHeading}>{name}</span>
          </span>
          {!isCourseExpired ? (<Chip
              label={status && _.capitalize(status)}
              className={status && this.getStatusColorCode(status)}
              classes={{ label: classes.chipLabel,
              root: classes.chipStyle }} variant="outlined"
              component="a"
            />): (<Chip
              label={expiredStatus && _.capitalize(expiredStatus)}
              className={expiredStatusFlag && this.getStatusColorCode(expiredStatusFlag)}
              classes={{ label: classes.chipLabel,
              root: classes.chipStyle }} variant="outlined"
              component="a"
            />)}
        </Grid>
        {editAddDuplicateContainerVisible ? (
          <Grid item xs="auto">
            {editContainerVisible && <>
              {status === 'PUBLISHED' && (
              <Tooltip
              placement="right-start"
              title={isEditDisabled||this.state.disableEditBttn?"You can edit course after the course is completely published":''}
              >
              <Button style={{
                color: '#666666',
                border: "1px solid #DDDDDD",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                marginRight: '10px'
              }}  color='primary'
               onClick={()=>{this.onEdit(isEditDisabled||this.state.disableEditBttn)}}  
               className={classNames((isEditDisabled||this.state.disableEditBttn) && classes.disabledCTA)}
                >Edit
              </Button>
              </Tooltip>
            )}
            </>}
            {/* {
              type != 'version' && */}
            {createContainerVisible && <>
              {!disablePublishButton &&
              <>
            <Button
              className={classes.addVersionBtn}
              // variant='contained'
              color='primary'
              disabled={!getPackageByIdData.coursePlanId || getPackageByIdData.status === 'DRAFT'||this.state.disableEditBttn}
              onClick={this.toggleVersionPopup.bind(this)}
            >
              + Add Version
            </Button>
            </>
               }
                {status === 'PUBLISHED' && getPackageByIdData.masterId ==null&& (
              <Button style={{
                color: '#666666',
                border: "1px solid #DDDDDD",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                marginRight: '10px',
                marginLeft: 10
              }}  color='primary' 
              onClick={this.duplicate} 
              className={classNames(!this.state.hasDuplicateRight && classes.disabledCTA)}
               disabled={!this.state.hasDuplicateRight}>
                Duplicate
              </Button>
            )}
          </>
          }
          </Grid>
        ) : <>
            {rejectedRequestVisible && <>
              {hasBasPlanUpdated && <Button
                className='btn-text'
                variant='contained'
                color='primary'
                onClick={() => this.handleRejection(REQUEST_STATUS.CLOSED)}
              >
                Close Request
              </Button>}
              <Button
                className={cx('btn-text', classes.mLeft5)}
                variant='contained'
                color='primary'
                onClick={() => this.handleRejection(REQUEST_STATUS.REJECTED)}
              >
                Reject Request
              </Button>
            </>}
          {publishContainerVisible && <Button
            className={classes.mLeft5}
            variant='contained'
            color='primary'
            onClick={this.handlePublishCourse}
          >
            {this.getPublishText()}
          </Button>}
        </>}
      </Grid>
    )
  }


  toggleCoursePlanViewModal = () => {
    this.setState({ coursePlanViewModelVisible: !this.state.coursePlanViewModelVisible });
  }

  handleCoursePlanView = (activeCoursePlanView: string) => {
    let viewList: string[];
    switch (activeCoursePlanView) {
      case ENTITY_TYPE.WEEK:
        viewList = [ENTITY_TYPE.PHASE];
        break;
      case ENTITY_TYPE.CHAPTER:
        viewList = [ENTITY_TYPE.PHASE, ENTITY_TYPE.WEEK];
        break;
      default:
        viewList = [];
        break;
    }
    this.toggleCoursePlanViewModal();
    this.setState({ activeCoursePlanView });
    this.props.setActiveCoursePlanView(viewList);
  }

  render = () => {
    const { classes, getPackageByIdData } = this.props;
    const { activeTab, showVersionPopup, showEditLockPopUp, showHistoryDropDown, historyList, coursePlanViewModelVisible, activeCoursePlanView } = this.state;
    const enableAdvanceSetting = (getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId === null) || (getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId != null);
    return (
      <>
      <Grid item style={{ marginBottom: '0', marginLeft: '15px', marginTop: '1px' }}>
        {this.renderHeadingComponent()}
      <Grid className={classes.tabContainer}>
        <Tabs
          className='tabsSec'
          value={activeTab}
          onChange={this.handleTabSwitch}
          aria-label='simple tabs example'
        >
          <Tab
            label='Course Plan'
            {...this.a11yProps(0)}
            className={this.state.activeTab === 0 ? classes.active_tab : classes.default_tabStyle}
          />
          <Tab
            label='Basic Info'
            {...this.a11yProps(1)}
            className={this.state.activeTab === 1 ? classes.active_tab : classes.default_tabStyle}
          />
          <Tab
            label='Advance Setting'
            {...this.a11yProps(2)}
            className={this.state.activeTab === 2 ? classes.active_tab : classes.default_tabStyle}
          />
          <Tab
            label='Hours Allocation'
            {...this.a11yProps(3)}
            className={this.state.activeTab === 3 ? classes.active_tab : classes.default_tabStyle}
          />
        {historyList.length &&
        <ClickAwayListener onClickAway={this.handleClickOutside.bind(this)}>
          <div className={classes.viewHistoryDropdown}>
            <div className='viewHistoryButton' onClick={this.toggleHistoryDropDown}>View History <img src="/assets/svg/course-plan-request/select-arrow-dark.svg" alt="Arrow" /></div>
            { showHistoryDropDown &&
            <div className='viewHistoryDropdownListBox'>
              <span className='arrowIcon'></span>
              <ul className='viewHistoryDropdownList'>
                {historyList.map((history: any) => {
                    return (<li>
                      <div className='historyContent'>
                        <div className='dateTimeColumn'>
                          <p>{this.getDayOfWeek(history.requestDate) + ', ' + this.convertDateFormat(history.requestDate)} <span className='timeCol'>{this.getFormattedTime(history.requestDate)}</span></p>
                        </div>
                        <span className='timeLineCircle'></span>
                        <div className='contentColumn'>
                          <p>{this.getHistoryTitle(history.requestType, history.centreName, history.userName)}</p>
                        </div>
                      </div>
                      <div className='viewDetailsRow'>
                        <span className='viewDetailsBtn' onClick={() => this.handleHistoryClick(history.requestId)}>View details</span>
                      </div>
                    </li>)
                  })}
              </ul>
            </div>
            }
          </div>
        </ClickAwayListener>
          }
        </Tabs>

        
       
        {/* <Grid justify="space-between">
              <P
              </Grid> */}
       
        <TabPanel value={activeTab} index={0}>
          <Grid className={classes.tabArea}>
            <CoursePlanPreview showVersionPopup={showVersionPopup} toggleVersionPopup={this.toggleVersionPopup}/>
          </Grid>
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <Grid className={classes.tabArea}>
            <BasicInfo basicInfoType={BasicInfoType.standard} 
            basicInfo={this.props.getPackageByIdData} editMode={false}
            showMenuIcon={enableAdvanceSetting === true?true:false}/>
          </Grid>
        </TabPanel>
        <TabPanel value={activeTab} index={2}>
          <Grid className={classes.tabArea}>
            <AdvancedSettings 
              isPreview={true}
            />
          </Grid>
        </TabPanel>
        <TabPanel value={activeTab} index={3}>
          <Grid className={classes.tabArea}>
            <HourAllocation
            isPreview={true}
            />
          </Grid>
        </TabPanel>
        {!activeTab && <button onClick={this.toggleCoursePlanViewModal} className={classes.planSummary}><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
         <g id="ic:sharp-calendar-view-day">
           <path id="Vector" d="M2 11.1207H14V12.5H8H2V11.1207ZM2 6.25862H14V9.74138H2V6.25862ZM2 3.5H14V4.87931H2V3.5Z" fill="#1D7DEA" />
         </g>
       </svg> Plan Summary
       </button>}
      </Grid>
      </Grid>
      {showVersionPopup && <CourseVersionPopup 
        showVersionPopup={showVersionPopup} 
        toggleVersionPopup={this.toggleVersionPopup}
        packageResponse={getPackageByIdData}
        goalList={this.state.goalList}
      />}
       {showEditLockPopUp && <EditLockedInfoPopUp 
        showPopupDialog={showEditLockPopUp} 
        isEditMode={false}
        onDialogClose={this.toggleEditPopUp}
      />}
         <MyPATDialog
          dialogOpen={coursePlanViewModelVisible}
          onDialogClose={this.toggleCoursePlanViewModal}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: 'sm',
          }}
        >
          <Grid container justify="center" className={classes.selectViewContainer}>
            <img className={classes.close} src="/assets/img/closeIcon.svg" alt="Close" onClick={this.toggleCoursePlanViewModal} />
            <Grid item xs={12} className={classes.selectImg}>
              <img src="/assets/img/select-view.svg" alt="Select View" />
            </Grid>
            <Grid item xs={12}>
              <h1 className={classes.headingText}>Select View</h1>
            </Grid>
            <p className={classes.paraText}>Information will be displayed based on the option selected</p>
            <ul className={classes.viewList}>
              {COURSE_VIEW_LIST.map(view => <li className={cx({ 'active': activeCoursePlanView === view.key })}
                onClick={() => this.handleCoursePlanView(view.key)} key={view.key}>{view.label}</li>)}
            </ul>
          </Grid>
        </MyPATDialog>
    </>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    getPackageByIdData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData.packageData', {}),
    viewPlanData: _.get(state, 'courseMangementData.contentManagementData.viewPlanData', {}),
    courseRequest: state.courseMangementData.courseManagementReducer.courseRequest
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setPackageById: contentManagementAction.setPackageById,
      showMsg,
      rejectCourse,
      approveAndPublishCourse,
      setRejectionRemark: courseManagementActions.setRejectionRemark,
      setCourseRequest: courseManagementActions.setCourseRequest,
      setActiveCoursePlanView: contentManagementAction.setActiveCoursePlanView
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseLandingPageStyles)(PreviewLandingPage));

